import { render, staticRenderFns } from "./objectTagEdit.vue?vue&type=template&id=b909729a"
import script from "./objectTagEdit.vue?vue&type=script&lang=js"
export * from "./objectTagEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b909729a')) {
      api.createRecord('b909729a', component.options)
    } else {
      api.reload('b909729a', component.options)
    }
    module.hot.accept("./objectTagEdit.vue?vue&type=template&id=b909729a", function () {
      api.rerender('b909729a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/objectTag/objectTagEdit.vue"
export default component.exports